/**
 * Punto de extensión del arranque: las features nuevas pueden registrarse aquí
 * sin editar el flujo legacy de `bootstrapMlvApp.js`.
 *
 * En `mlvFeatureRegistrations.js` importá un `mlvBootstrapRegister.js` por feature
 * que llame a `registerMlvExtension`.
 */

const hooks = [];

/** @param {(ctx: object) => void} fn */
export function registerMlvExtension(fn) {
  if (typeof fn === 'function') hooks.push(fn);
}

/** @param {object} ctx Referencias de arranque (repos, presenters, navegación). */
export function runMlvExtensionsReady(ctx) {
  for (const fn of hooks) {
    try {
      fn(ctx);
    } catch (e) {
      console.error('[MLV] Error en extensión de arranque:', e);
    }
  }
}
